import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import type { SeverityLabel } from "@/v2-backoffice-client/layer/drift/layer.drift.utils"

export type LayerDriftSeverityBadgeProps = ComponentProps<"span"> & {
  severity: SeverityLabel
}

// LayerDriftSeverityBadge is the small pill that labels a single
// severity level. Reused from both the table section headers and the
// summary-counts row in the tab header so the colour palette stays
// in one place.
function LayerDriftSeverityBadge(props: LayerDriftSeverityBadgeProps) {
  const { severity, className, children, ...spanProps } = props
  return (
    <span
      className={cn(
        "inline-block text-[10px] uppercase tracking-wider font-semibold px-1.5 py-0.5 rounded border",
        SEVERITY_CLASSES[severity],
        className,
      )}
      {...spanProps}
    >
      {children}
    </span>
  )
}

// Severity-specific palette. Kept as a record (instead of a switch)
// so the supported set is statically exhaustive on SeverityLabel.
const SEVERITY_CLASSES: Record<SeverityLabel, string> = {
  breaking: "bg-destructive/10 text-destructive border-destructive/30",
  warning: "bg-amber-500/10 text-amber-500 border-amber-500/30",
  info: "bg-violet-500/10 text-violet-500 border-violet-500/30",
}

export default LayerDriftSeverityBadge
